module.exports = __webpack_public_path__ + "img/instrument-statistics.c846846e.png";